import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a39ded9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__progress-area" }
const _hoisted_2 = {
  key: 0,
  class: "area-title"
}
const _hoisted_3 = {
  key: 1,
  class: "area-subtitle"
}
const _hoisted_4 = { class: "button-container print--hide" }
const _hoisted_5 = { class: "button-prev" }
const _hoisted_6 = { class: "button-next print--hide" }
const _hoisted_7 = {
  key: 0,
  class: "button-container--inner"
}
const _hoisted_8 = {
  key: 0,
  class: "save-as-draft-explanation"
}

import { computed, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';
  import { themingCssClass } from "../../mixins/theming-mixin"
  import { recProps } from '../../mixins/rec-component';
  import SimpleButton from "vue/applications/frontend/components/simple-button.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-progress-area',
  props: {...recProps()},
  emits: ["submit"],
  setup(__props, { emit: __emit }) {

  const props = __props;
  const emit = __emit;

  const store = useStore();
  const currentAreaPointer = ref<number>(0);

  onMounted(() => {
   store.commit("updateCurrentAreaKey", props.description.areas[0].key);
  });

  const activeAreaKey = computed(() => store.state.exam.currentAreaKey);
  const activeAreaIndex = computed(() => {
    let index = 0;
    for (const area of props.description.areas) {
      if (area.key === activeAreaKey.value) {
        return index;
      }
      index += 1;
    }
    return index;
  });

  const isLast = computed(() => activeAreaIndex.value + 1 == props.description.areas.length);

  const isFirst = computed(() => activeAreaIndex.value == 0)

  const next = () => {
    const nextIndex =
      (activeAreaIndex.value + 1) % props.description.areas.length;
    store.commit(
      "updateCurrentAreaKey",
      props.description.areas[nextIndex].key,
    );
  };

  const prev = () => {
    const prevIndex =
      (props.description.areas.length + activeAreaIndex.value - 1) %
      props.description.areas.length;
    store.commit(
      "updateCurrentAreaKey",
      props.description.areas[prevIndex].key,
    );
  };

  const submit = () => {
    if (!props.description.readonly) {
      emit("submit");
    } else {
      console.error("Submitting is not allowed for a readonly form");
    }
  };

  const submitAsDraft = () => {
    if (!props.description.readonly) {
      emit("submit-as-draft");
    } else {
      console.error("Submitting as draft is not allowed for a readonly form");
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.areas, (area) => {
      return (_openBlock(), _createElementBlock("div", {
        key: area.key,
        class: _normalizeClass(["progress-single-area print--show", { inactive: area.key !== activeAreaKey.value }])
      }, [
        (area.area_title || area.area_subtitle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["area-header print--avoid-break-page-after", [_unref(themingCssClass)('normal')]])
            }, [
              (area.area_title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(area.area_title), 1))
                : _createCommentVNode("", true),
              (area.area_subtitle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(area.area_subtitle), 1))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent(area.component), {
          description: area,
          onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('submit')))
        }, null, 40, ["description"]))
      ], 2))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (!isFirst.value)
          ? (_openBlock(), _createBlock(SimpleButton, {
              key: 0,
              "use-theming": "",
              class: "button-a",
              onMainAction: prev
            }, {
              default: _withCtx(() => [
                _createTextVNode("Zurück")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (isLast.value && !_ctx.description.readonly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.description.exam_is_draft)
                ? (_openBlock(), _createBlock(SimpleButton, {
                    key: 0,
                    "use-theming": "",
                    class: "button-a",
                    onMainAction: submitAsDraft
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Als Entwurf speichern")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(SimpleButton, {
                "use-theming": "",
                class: "button-a",
                onMainAction: submit,
                filled: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Speichern")
                ]),
                _: 1
              })
            ]))
          : (!isLast.value)
            ? (_openBlock(), _createBlock(SimpleButton, {
                key: 1,
                "use-theming": "",
                class: "button-a",
                onMainAction: next
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Weiter")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ])
    ]),
    (isLast.value && !_ctx.description.readonly && _ctx.description.exam_is_draft)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Wenn Sie den Bogen als Entwurf speichern, ist er zunächst nur für Sie sichtbar. Sie können den Bogen nach dem Speichern jederzeit bearbeiten. "))
      : _createCommentVNode("", true)
  ]))
}
}

})